
export default class AdUnits {
  constructor(listener) {
    this.subscribe()
  }

  subscribe() {
    window.vpaid.subscribe(this.adStarted, 'AdStarted', this);
    window.vpaid.subscribe(this.adPaused, 'AdPaused', this);
    window.vpaid.subscribe(this.adStopped, 'AdStopped', this);
    window.vpaid.subscribe(this.adVolumeChanged, 'AdVolumeChange', this);
    window.vpaid.subscribe(this.adHandleTimeUpdate, 'AdVideoFirstQuartile', this);
  }

  unsubscribe() {
    
  }

  registerListener(listener) {
    this.listener = listener;
  }

  emit(evt, params) {
    try {
      this.listener && this.listener(evt, params);
    } catch(e) {
      console.log('call for this.listener failed', e);
    }
  }

  adStarted() {
    // console.log('---------------------------------------> AdStarted');
  }

  adPaused() {
    this.emit('AdPaused');
  }

  adStopped() {
    this.emit('AdStopped');
  } 

  adVolumeChanged(volume) {
    console.log('AdVolumeChange called');
    this.emit('AdVolumeChange', volume);
  }
  
  adHandleTimeUpdate() {
    // this.emit('')
    // console.log('adHandleTimeUpdate quarter');
  }
}


// WEBPACK FOOTER //
// ./components/adunits/index.js